var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-base',{attrs:{"url":_vm.url,"columns":_vm.columns,"enableSearch":true,"on-update":() => {},"formInputs":_vm.formInputs,"primaryKey":"id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }